import { render } from "./7.ClientsSection.vue?vue&type=template&id=ae42d8e4&scoped=true"
import script from "./7.ClientsSection.vue?vue&type=script&lang=js"
export * from "./7.ClientsSection.vue?vue&type=script&lang=js"

import "./7.ClientsSection.vue?vue&type=style&index=0&id=ae42d8e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae42d8e4"]])

export default __exports__